import styled from 'styled-components';
import { themeMode, color, fontSize, lineHeight, spacing, palette, variant } from '../../utils/theme.es.js';
import { RadioPrimitive } from './RadioPrimitive/RadioPrimitive.es.js';
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      width: spacing(4),
      height: spacing(4),
      marginTop: spacing(1)
    },
    md: {
      width: spacing(4),
      height: spacing(4),
      marginTop: spacing(1)
    },
    lg: {
      width: spacing(6),
      height: spacing(6)
    }
  }
});
var Control = styled(RadioPrimitive.Control).withConfig({
  componentId: "sc-6w2l1p-0"
})(["display:flex;justify-content:center;align-content:center;align-items:center;border-radius:100em;overflow:hidden;position:relative;flex-shrink:0;transition:opacity 200ms ease-in;border:1px solid ", ";color:", ";", ";"], themeMode({
  light: palette("neutral.500"),
  dark: palette("neutral.400")
}), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), sizeStyles);
Control.displayName = "Radio.Control";
var labelSizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      lineHeight: "sm"
    },
    md: {
      fontSize: "md",
      lineHeight: "md"
    },
    lg: {
      fontSize: "lg",
      lineHeight: "md"
    }
  }
});
var Label = styled(RadioPrimitive.Label).withConfig({
  componentId: "sc-6w2l1p-1"
})(["color:", ";user-select:none;", ";"], function (_ref) {
  var isDisabled = _ref.isDisabled;
  return color(isDisabled ? "text.muted" : "text.base");
}, labelSizeStyles);
Label.displayName = "Radio.Label";
var Description = styled(RadioPrimitive.Description).withConfig({
  componentId: "sc-6w2l1p-2"
})(["font-size:", ";line-height:", ";color:", ";"], fontSize("sm"), lineHeight("xs"), color("text.subtle"));
Description.displayName = "Radio.Description";
var Radio = styled(RadioPrimitive.Root).withConfig({
  componentId: "sc-6w2l1p-3"
})(["display:flex;flex-direction:row;align-items:flex-start;padding:", ";&[data-state='checked'] > div:first-of-type{&:before{content:'';width:50%;height:50%;position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0);border-radius:100em;background-color:", ";}}&[data-state='checked']:not([data-disabled='true']) > div:first-of-type{background-color:", ";border-color:", ";&:hover{background-color:", ";}}&[data-disabled='true'][data-state='checked'] > div:first-of-type{background-color:", ";&:hover{background-color:", ";}}&[data-disabled='true'] > div:first-of-type{border-color:", ";}&[data-invalid='true'] > div:first-of-type{border-color:", ";}&:hover{cursor:pointer;}&[data-disabled='true']{&:hover{cursor:not-allowed;}}"], spacing("xs"), themeMode({
  light: palette("neutral.50"),
  dark: palette("neutral.900")
}), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), themeMode({
  light: palette("neutral.700"),
  dark: palette("neutral.200")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), palette("danger.500"));
Radio.displayName = "Radio";
export { Control, Description, Label, Radio };